import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUseCase } from '@lib/plugin-redux-core';
import { FIND_GROUPED_QUESTIONS_BY_SECTION_USE_CASE, FIND_FORM_BY_ID_USE_CASE, FIND_FORM_RELEASE_BY_ID_USE_CASE, FIND_QUESTION_RELEASES_USE_CASE } from '@module/form';
import { UPDATE_SELECTED_SECTION } from '../../../redux/root.action';
import { usePin } from '@module/form-components';
export var useFormPreview = function useFormPreview(_ref) {
  var _page$questions, _page$selectedSection, _page$sectionSummarie;

  var formId = _ref.formId,
      formPreviewLabels = _ref.formPreviewLabels,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'normal-form' : _ref$type;
  var dispatch = useDispatch();
  var questionLabel = formPreviewLabels.question;
  var sectionLabel = formPreviewLabels.section;
  var page = useSelector(function (state) {
    return state.formPreviewApp;
  });
  var questions = (_page$questions = page === null || page === void 0 ? void 0 : page.questions) !== null && _page$questions !== void 0 ? _page$questions : [];
  var selectedSection = page === null || page === void 0 ? void 0 : page.selectedSection;
  var selectedSectionIndex = (_page$selectedSection = page === null || page === void 0 ? void 0 : page.selectedSectionIndex) !== null && _page$selectedSection !== void 0 ? _page$selectedSection : 0;
  var sectionSummaries = (_page$sectionSummarie = page === null || page === void 0 ? void 0 : page.sectionSummaries) !== null && _page$sectionSummarie !== void 0 ? _page$sectionSummarie : [];
  var form = page === null || page === void 0 ? void 0 : page.form; // Use the separate pin hook

  var _usePin = usePin({
    questions: questions,
    selectedSection: selectedSection,
    selectedSectionIndex: selectedSectionIndex,
    questionLabel: questionLabel,
    sectionLabel: sectionLabel
  }),
      pinnedSectionId = _usePin.pinnedSectionId,
      pinnedQuestionId = _usePin.pinnedQuestionId,
      pinStatus = _usePin.pinStatus,
      setPinStatus = _usePin.setPinStatus,
      onCancelPin = _usePin.onCancelPin,
      onPinQuestion = _usePin.onPinQuestion,
      onPinSection = _usePin.onPinSection,
      renderPinnedQuestionOrSection = _usePin.renderPinnedQuestionOrSection;

  var handleGetFormById = useCallback(function () {
    if (type === 'form-release') {
      var findFormReleaseByIdUseCase = getUseCase(FIND_FORM_RELEASE_BY_ID_USE_CASE, dispatch);
      findFormReleaseByIdUseCase.execute(formId);
    } else {
      var findFormByIdUseCase = getUseCase(FIND_FORM_BY_ID_USE_CASE, dispatch);
      var findFormByIdUseCaseParams = {
        id: formId
      };
      findFormByIdUseCase.execute(findFormByIdUseCaseParams);
    }
  }, [dispatch, formId, type]);
  useEffect(function () {
    handleGetFormById();
  }, [handleGetFormById]);
  useEffect(function () {
    if (form) {
      if (type === 'form-release') {
        var findQuestionReleasesUseCase = getUseCase(FIND_QUESTION_RELEASES_USE_CASE, dispatch);
        findQuestionReleasesUseCase.execute({
          formReleaseId: formId
        });
      } else {
        var findQuestionsUseCase = getUseCase(FIND_GROUPED_QUESTIONS_BY_SECTION_USE_CASE, dispatch);
        var findQuestionsUseCaseInput = {
          form: form,
          isGroupedBySection: true
        };
        findQuestionsUseCase.execute(findQuestionsUseCaseInput);
      }
    }
  }, [dispatch, form, type, formId]);
  var updateSelectedSection = useCallback(function (section) {
    var updateSelectedSectionUseCase = getUseCase(UPDATE_SELECTED_SECTION, dispatch);
    updateSelectedSectionUseCase.execute({
      selectedSection: section
    });
  }, [dispatch]);
  return {
    pinnedSectionId: pinnedSectionId,
    pinnedQuestionId: pinnedQuestionId,
    pinStatus: pinStatus,
    setPinStatus: setPinStatus,
    onCancelPin: onCancelPin,
    onPinQuestion: onPinQuestion,
    onPinSection: onPinSection,
    renderPinnedQuestionOrSection: renderPinnedQuestionOrSection,
    sectionSummaries: sectionSummaries,
    selectedSection: selectedSection,
    updateSelectedSection: updateSelectedSection
  };
};